import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import TickerBar from "@/components/feature/TickerBar";
import BackToTop from "@/components/feature/BackToTop";
import { useSeo } from "@/hooks/useSeo";
import Hero from "./components/Hero";
import LatestBoard from "./components/LatestBoard";
import CategorySection from "./components/CategorySection";
import ProcessSection from "./components/ProcessSection";
import FaqSection from "./components/FaqSection";
import CtaSection from "./components/CtaSection";

const SEO_TITLE = "网报吃瓜 - 网报吃瓜官方声明、通报、辟谣回应与调查进展时间线";
const SEO_DESC =
  "网报吃瓜对接收官方通报、声明、回应与辟谣，把碎片信息还原成可复盘的时间线。遇到事件先看官方是否发声、声明原文怎么说、辟谣和调查进展到哪一步，减少被二手转述带着跑。";
const SEO_KEYWORDS =
  "网报吃瓜,网报吃瓜官方,网报吃瓜通报,网报吃瓜声明,网报吃瓜回应,网报吃瓜辟谣,网报吃瓜调查";

const JSON_LD = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebSite",
      name: "网报吃瓜",
      url: "https://sxdayun.com.cn/",
      description: SEO_DESC,
      potentialAction: {
        "@type": "SearchAction",
        target: "https://sxdayun.com.cn/events?q={search_term_string}",
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@type": "Organization",
      name: "网报吃瓜",
      url: "https://sxdayun.com.cn/",
      email: "contact@wangbao-chigua.site",
      description: "收录官方通报、声明、回应与辟谣原文，整理成可复盘时间线的中文信息索引站。",
    },
    {
      "@type": "WebPage",
      name: SEO_TITLE,
      description: SEO_DESC,
      url: "https://sxdayun.com.cn/",
      isPartOf: { "@type": "WebSite", url: "https://sxdayun.com.cn/" },
    },
  ],
};

export default function Home() {
  useSeo({
    title: SEO_TITLE,
    description: SEO_DESC,
    keywords: SEO_KEYWORDS,
    path: "/",
    jsonLd: JSON_LD,
  });

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <TickerBar />
      <main className="w-full">
        <Hero />
        <LatestBoard />
        <CategorySection />
        <ProcessSection />
        <FaqSection />
        <CtaSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}